import axios from '../../axios';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { TCreatePost, TPostBase, TError } from '@onesource/schemas';
import { getPostsQueryKey } from './get-posts';
import { getPostsInfiniteQueryKey } from './get-posts-infinite';

/**
 * Hook to create a new post in a space
 * Automatically invalidates both regular and infinite posts list for the space on success
 *
 * @param spaceId - Space ID (UUID) where the post will be created
 */
export const useCreatePost = (spaceId: string) => {
  const queryClient = useQueryClient();

  return useMutation<TPostBase, TError, TCreatePost>({
    mutationFn: async data => {
      const res = await axios.post<TPostBase>(`/community-hub/spaces/${spaceId}/posts`, data);
      return res.data;
    },
    onSuccess: () => {
      // Invalidate both regular and infinite posts list to trigger refetch
      queryClient.invalidateQueries({ queryKey: getPostsQueryKey(spaceId) });
      queryClient.invalidateQueries({ queryKey: getPostsInfiniteQueryKey(spaceId) });
    },
  });
};
